module.exports = __webpack_public_path__ + "img/btn_kuangxuan.b6d6b9f5.png";